// VERSION: 6.0.916
// IMPORTANT: When updating taas_app version data, update the version number in this comment on the first line
// This version number is used by the backend API endpoint get_VersionData
export const versionContentData = {
  date: "October 30, 2025",
  features: [
    {
      title: "Pacifica DEX Integration",
      items: [
        {
          title: "Perpetual Trading",
          description: "Added support for Pacifica DEX perpetual trading.",
          image: {
            src: "https://luminous-ganache-c828dc.netlify.app/images/treadfipacifica.jpg",
            alt: "Pacifica DEX Integration"
          }
        }
      ]
    },
  ]
};
